import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-credit-outstanding-indetails',
  templateUrl: './credit-outstanding-indetails.component.html',
  styleUrl: './credit-outstanding-indetails.component.scss'
})
export class CreditOutstandingIndetailsComponent {


  
   currentDate: Date;
  creditoutstandingindetails: any;
  creditonlyOutStandingIDTotal: number;
  creditonlyOutStandingIDNetAmtTotal: number;
  creditonlyOutStandingIDUnPaidTotal: number;
  
  
    
      constructor(
        private dialogRef: MatDialogRef<CreditOutstandingIndetailsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService,
        private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
      ) {
       
      }
  
      
  
    reportType:any
    startDate :any
    endDate :any
    repName :any
    offRepName:any
    advtName :any
    issueDates:any
    issueDates1:any
    OutstandingInDetailFormBeans:any
  
    OutStandingIDTotal: number = 0;
    OutStandingIDNetAmtTotal: number = 0;
    OutStandingIDUnPaidTotal: number = 0;




    ngOnInit(): void {
  
      this.currentDate = new Date();
      debugger
      this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['offRepName'];
      this.advtName = this.data['name'];
      this.issueDates = this.data.issueDates;
      this.issueDates1 = this.data['issue_date'];
  
      const req: any = {
        "rep_name":  this.repName,
        "start_date": this.startDate,
        "end_date": this.endDate,
        "off_rep_name": this.offRepName,
        "advt_name": this.data['name'],
        // // "issue_name" : this.advtName,
        // "issue_date": this.issueDates
        "issue_name": "",
        "issue_date": this.issueDates1
  
  
      }
  

    //      this.service.creditoutstaqndingindetails(req).subscribe((data: any) => {
    //   console.log("credit outstanding ", data)
    //   this.creditoutstandingindetails = data as any;

    //   // this.creditonlyOutStandingIDTotal = 0;
    //   // this.creditonlyOutStandingIDNetAmtTotal = 0;
    //   // this.creditonlyOutStandingIDUnPaidTotal = 0;
    //   for (let data of this.creditoutstandingindetails) {
    //     for (let data1 of data.rep_data) {
    //       this.creditonlyOutStandingIDTotal += parseInt(data1.advt_amt_total) || 0;
    //       this.creditonlyOutStandingIDNetAmtTotal += parseInt(data1.net_amt_total) || 0;
    //       this.creditonlyOutStandingIDUnPaidTotal += parseInt(data1.unpaid_amt_total) || 0;
    //     }
    //   }
    // });
     
  
    // Add these properties in your component class


// Add this helper function in your component class


// Your service call
this.service.creditoutstaqndingindetails(req).subscribe((data: any) => {
  console.log("credit outstanding ", data);
  this.creditoutstandingindetails = data as any;

  // Reset totals before calculation
  this.creditonlyOutStandingIDTotal = 0;
  this.creditonlyOutStandingIDNetAmtTotal = 0;
  this.creditonlyOutStandingIDUnPaidTotal = 0;

  // Calculate grand totals
  if (this.creditoutstandingindetails && this.creditoutstandingindetails.length > 0) {
    for (let officeRep of this.creditoutstandingindetails) {
      if (officeRep.rep_data && officeRep.rep_data.length > 0) {
        for (let rep of officeRep.rep_data) {
          this.creditonlyOutStandingIDTotal += parseFloat(rep.advt_amt_total) || 0;
          this.creditonlyOutStandingIDNetAmtTotal += parseFloat(rep.net_amt_total) || 0;
          this.creditonlyOutStandingIDUnPaidTotal += parseFloat(rep.unpaid_amt_total) || 0;
        }
      }
    }
  }
  
  console.log("Totals calculated:", {
    advt_total: this.creditonlyOutStandingIDTotal,
    net_total: this.creditonlyOutStandingIDNetAmtTotal,
    unpaid_total: this.creditonlyOutStandingIDUnPaidTotal
  });
});
  
    }
  
  getOfficeRepTotal(repData: any[], field: string): number {
  if (!repData || repData.length === 0) {
    return 0;
  }
  let total = 0;
  for (let rep of repData) {
    total += parseFloat(rep[field]) || 0;
  }
  return total;
}

      
//   print() {
//     const originalTitle = document.title;
//     document.title = '';
  
//     const style = document.createElement('style');
//     style.innerHTML = `
//       @media print {
//   @page {
//     size: A4 portrait;
//     margin: 10mm;
//   }

//   * {
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }

//   html, body {
//     margin: 0 !important;
//     padding: 0 !important;
//     width: 100% !important;
//     height: 100% !important;
//     background: #fff !important;
//     color: #000 !important;
//   }

//   .noPrint {
//     display: none !important;
//   }

//   .container {
//     display: flex !important;
//     justify-content: center !important;
//     align-items: center !important;
//     width: 100% !important;
//     height: 100% !important;
//     margin: 0 !important;
//     padding: 0 !important;
//   }

//   .report-wrapper {
//     display: flex !important;
//     justify-content: center !important;
//     align-items: center !important;
//     width: 100% !important;
//     padding: 0 !important;
//     margin: 0 !important;
//   }

//   .report-table {
//     width: auto !important;
//     font-size: 14px !important;
//     table-layout: auto !important;
//     margin: 0 auto !important;
//     border-collapse: collapse !important;
//   }

//   .report-table th,
//   .report-table td {
//     padding: 6px 8px !important;
//     border: 1px solid #000 !important;
//     white-space: nowrap !important;
//     font-size: 14px !important;
//     width: auto !important;
//     min-width: unset !important;
//   }

//   /* Ensure colors print correctly */
//   .report-table th {
//     background-color: #f0f0f0 !important;
//     color: #000 !important;
//   }
  
//   .report-table thead tr:first-child th {
//     background-color: #d9ead3 !important;
//     color: #000 !important;
//   }
  
//   .report-table thead tr:nth-child(2) th {
//     background-color: #fce5cd !important;
//     color: #000 !important;
//   }
  
//   .report-table thead tr:nth-child(3) th {
//     background-color: #d9d2e9 !important;
//     color: #000 !important;
//   }
  
//   .report-table .off_rep_name {
//     background-color: #d9ead3 !important;
//     color: #000 !important;
//   }
  
//   .report-table .rep_name {
//     background-color: #fff2cc !important;
//     color: #000 !important;
//   }
  
//   .report-table tr.total-row td {
//     background-color: #f3f3f3 !important;
//     color: #000 !important;
//   }

//   /* Ensure table rows don't break across pages */
//   .report-table, .report-table tr, .report-table th, .report-table td {
//     page-break-inside: avoid !important;
//   }
// }
//     `;
  
//     document.head.appendChild(style);
  
//     setTimeout(() => {
//       const printTrigger = document.getElementById('print-button');
//       if (printTrigger) {
//         (printTrigger as HTMLElement).click();
//       }
//       document.title = originalTitle;
//     }, 500);
//   }



print() {
  const originalTitle = document.title;
  document.title = '';

  const style = document.createElement('style');
  style.innerHTML = `
    @media print {
      @page {
        size: A4 portrait;
        margin: 14mm 12mm;
      }


       * {
     -webkit-print-color-adjust: exact !important;
     print-color-adjust: exact !important;
   }

       .container {
  font-family: Arial, sans-serif;
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.report-wrapper {
  width: auto;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.small-text {
  font-size: 14px;
}

.bold-text {
  font-weight: bold;
}

.text-end {
  text-align: right;
}

.ft-wt-200 {
  font-weight: 200;
}

/* ====================== TABLE STYLES ====================== */
.report-table {
  width: auto !important;
  border-collapse: collapse;
  margin-bottom: 20px;
  font-size: 14px;
  page-break-inside: avoid;
  table-layout: auto;
}

.report-table th,
.report-table td {
  border: 1px solid #000;
  padding: 8px;
  white-space: nowrap;
  color: #000 !important;
  font-size: 14px;
}

.report-table th {
  background-color: #f0f0f0;
  font-weight: bold;
  text-align: center;
  color: #000 !important;
}

/* Header row styles */
.report-table thead tr:first-child th {
  background-color: #d9ead3;
  font-size: 14px;
  padding: 8px;
}

.report-table thead tr:nth-child(2) th {
  background-color: #fce5cd;
  font-size: 14px;
  padding: 8px;
}

.report-table thead tr:nth-child(3) th {
  background-color: #d9d2e9;
  font-size: 14px;
  padding: 8px;
}

/* Office Representative row */
.report-table .off_rep_name {
  background-color: #d9ead3;
  font-weight: bold;
  padding: 8px;
  font-size: 14px;
  color: #000 !important;
}

/* Representative row */
.report-table .rep_name {
  background-color: #fff2cc;
  font-weight: bold;
  padding: 8px;
  font-size: 14px;
  color: #000 !important;
}

/* Data rows */
.report-table tbody tr:not(.off_rep_name):not(.rep_name) {
  background-color: #ffffff;
}

/* Amount columns - right aligned */
.report-table .text-end {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  text-align: right !important;
  padding-right: 10px !important;
}

/* Total rows */
.report-table tr.total-row td {
  background-color: #f3f3f3;
  font-weight: bold;
  color: #000 !important;
}

/* Minimal column widths - only as wide as content needs */
.report-table td,
.report-table th {
  width: auto;
  min-width: unset;
  max-width: none;
}

/* ====================== BORDER HELPERS ====================== */
.br-bottom {
  border-bottom: 1px solid #000 !important;
}

.br-top {
  border-top: 1px solid #000 !important;
}

.br-right {
  border-right: 1px solid #000 !important;
}

.br-left {
  border-left: 1px solid #000 !important;
}

/* ====================== FOOTER & BUTTONS ====================== */
.footer-line {
  border-top: 1px solid #ddd;
  margin: 15px 0;
}

.actions {
  text-align: right;
  margin-top: 20px;
  margin-right: 20px;
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.actions button {
  padding: 8px 16px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

/* Button styles */
.btn-export {
  background-color: #4472C4;
  color: white;
  border: 1px solid #4472C4;
}

.btn-print {
  background-color: #4472C4;
  color: white;
  border: 1px solid #4472C4;
}

.btn-close {
  background-color: #70AD47;
  color: white;
  border: 1px solid #70AD47;
}

.btn-export:hover,
.btn-print:hover,
.btn-close:hover {
  opacity: 0.8;
}

.noPrint {
  display: block;
}
  `;

  document.head.appendChild(style);

  setTimeout(() => {
    const printTrigger = document.getElementById('print-button');
    if (printTrigger) {
      (printTrigger as HTMLElement).click();
    }
    document.title = originalTitle;
    
    // Clean up the style after printing
    setTimeout(() => {
      document.head.removeChild(style);
    }, 1000);
  }, 500);
}

    exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);
    
    let element = document.getElementById('print-section');
    console.log('Element found:', element);
    
    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }
    
    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);
      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

}
function getOfficeRepTotal(repData: any, arg1: any, field: any, string: any) {
  throw new Error('Function not implemented.');
}

